import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { Routes, rootRouteRef } from './routes';

export const confidenceSegmentsPlugin = createPlugin({
  id: 'confidence-flags-module-segments',
  routes: {
    ...Routes,
  },
});

export const ConfidenceSegmentsExtension = confidenceSegmentsPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceSegmentsExtension',
    component: () =>
      import(
        /* webpackChunkName: "confidence-flags-module-segments", webpackPrefetch: 10 */ './Router'
      ).then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
